(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bandz-dtf-pilot"] && !Shopify.designMode) return;
  try {
    
  function setupDtfPages() {
    document.querySelectorAll('[data-dtf-root]').forEach(root => {
      const selector=root.querySelector('[data-dtf-selector]');
      if(!selector||selector.dataset.dtfReady)return;
      selector.dataset.dtfReady='true';
      const messages=JSON.parse(root.querySelector('[data-dtf-messages]').textContent);
      const update=()=>{
        const selected=selector.selectedOptions[0];
        root.querySelector('[data-dtf-price]').textContent=selected.dataset.price;
        root.querySelector('[data-dtf-dimensions]').textContent=messages.canvas.replace('__LENGTH__',selected.dataset.length);
        const next=new URL(window.location.href);
        next.searchParams.set('variant',selector.value);
        window.history.replaceState({},'',next);
      };
      selector.addEventListener('change',update);
      update();
    });
  }
  setupDtfPages();
  document.addEventListener('shopify:section:load',setupDtfPages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["call-room-details"] && !Shopify.designMode) return;
  try {
    
  class BandzCallDetails extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.refresh();
      this.timer = window.setInterval(() => this.refresh(), 60000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.timer = null;
      if (this.calendarUrl) URL.revokeObjectURL(this.calendarUrl);
      this.calendarUrl = null;
    }

    zonedParts(date) {
      return Object.fromEntries(new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    }

    fromEastern(year, month, day, hour, minute) {
      const wall = Date.UTC(year, month - 1, day, hour, minute);
      let result = wall;
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const part = this.zonedParts(new Date(result));
        const represented = Date.UTC(part.year, part.month - 1, part.day, part.hour, part.minute, part.second);
        result += wall - represented;
      }
      return new Date(result);
    }

    occurrence(now) {
      const parts = this.zonedParts(now);
      const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
      date.setUTCDate(date.getUTCDate() + (8 - date.getUTCDay()) % 7);
      const [hour, minute] = (this.dataset.time || '21:00').split(':').map(Number);
      const duration = Number(this.dataset.duration) || 60;
      const startForDate = () => this.fromEastern(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), hour, minute);
      let start = startForDate();
      if (now.getTime() >= start.getTime() + duration * 60000) {
        date.setUTCDate(date.getUTCDate() + 7);
        start = startForDate();
      }
      const state = now >= start ? 'current' : now.getTime() >= start.getTime() - Number(this.dataset.early || 15) * 60000 ? 'early' : 'upcoming';
      return {start, end: new Date(start.getTime() + duration * 60000), state};
    }

    stamp(date, zone) {
      const p = this.zonedParts(date);
      if (!zone) return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
      const pad = value => String(value).padStart(2, '0');
      return `${p.year}${pad(p.month)}${pad(p.day)}T${pad(p.hour)}${pad(p.minute)}00`;
    }

    escapeCalendar(value) {
      return String(value || '').replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
    }

    calendar(start, end) {
      const esc = value => this.escapeCalendar(value);
      const lines = [
        'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Bandzlandia//Monday Call//EN', 'CALSCALE:GREGORIAN',
        'BEGIN:VTIMEZONE', 'TZID:America/New_York', 'X-LIC-LOCATION:America/New_York',
        'BEGIN:DAYLIGHT', 'TZOFFSETFROM:-0500', 'TZOFFSETTO:-0400', 'TZNAME:EDT',
        'DTSTART:20070311T020000', 'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU', 'END:DAYLIGHT',
        'BEGIN:STANDARD', 'TZOFFSETFROM:-0400', 'TZOFFSETTO:-0500', 'TZNAME:EST',
        'DTSTART:20071104T020000', 'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU', 'END:STANDARD', 'END:VTIMEZONE',
        'BEGIN:VEVENT', 'UID:weekly-monday-call@bandzlandia.com', `DTSTAMP:${this.stamp(new Date())}`,
        `DTSTART;TZID=America/New_York:${this.stamp(start, true)}`, `DTEND;TZID=America/New_York:${this.stamp(end, true)}`,
        'RRULE:FREQ=WEEKLY;BYDAY=MO', `SUMMARY:${esc(this.dataset.title)}`,
        `DESCRIPTION:${esc(this.dataset.description + '\n\n' + this.dataset.joinUrl)}`,
        `LOCATION:${esc(this.dataset.joinUrl)}`, `URL:${this.dataset.joinUrl}`,
        'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', `DESCRIPTION:${esc(this.dataset.title)}`, 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'
      ];
      return lines.map(line => {
        let folded = '', bytes = 0;
        for (const character of line) {
          const length = new TextEncoder().encode(character).length;
          if (bytes + length > 73) { folded += '\r\n '; bytes = 1; }
          folded += character;
          bytes += length;
        }
        return folded;
      }).join('\r\n') + '\r\n';
    }

    refresh() {
      try {
        const {start, end, state} = this.occurrence(new Date());
        if (Number.isNaN(start.getTime())) return;
        this.dataset.state = state;
        this.querySelector('[data-call-status]').textContent = state === 'early' ? this.dataset.earlyLabel : state === 'current' ? this.dataset.current : this.dataset.upcoming;
        this.querySelector('[data-call-date]').textContent = new Intl.DateTimeFormat(undefined, {timeZone:'America/New_York', weekday:'long', month:'long', day:'numeric'}).format(start);
        this.querySelector('[data-call-local]').textContent = `${this.dataset.localLabel} ${new Intl.DateTimeFormat(undefined, {weekday:'short', month:'short', day:'numeric', hour:'numeric', minute:'2-digit', timeZoneName:'short'}).format(start)}`;
        const params = new URLSearchParams({action:'TEMPLATE', text:this.dataset.title,
          dates:`${this.stamp(start, true)}/${this.stamp(end, true)}`, ctz:'America/New_York',
          recur:'RRULE:FREQ=WEEKLY;BYDAY=MO', details:this.dataset.description + '\n\n' + this.dataset.joinUrl, location:this.dataset.joinUrl});
        this.querySelector('[data-google-calendar]').href = `https://calendar.google.com/calendar/render?${params}`;
        if (this.calendarStart !== start.toISOString() || !this.calendarUrl) {
          if (this.calendarUrl) URL.revokeObjectURL(this.calendarUrl);
          this.calendarUrl = URL.createObjectURL(new Blob([this.calendar(start, end)], {type:'text/calendar;charset=utf-8'}));
          this.querySelector('[data-ics-calendar]').href = this.calendarUrl;
          this.calendarStart = start.toISOString();
        }
        this.querySelector('[data-call-calendar]').hidden = false;
      } catch (error) {
        this.querySelector('[data-call-calendar]').hidden = true;
      }
    }
  }
  if (!customElements.get('bandz-call-details')) customElements.define('bandz-call-details', BandzCallDetails);

  } catch(e) { console.error(e); }
})();
})();
